import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' >
                <img src='/assets/images/logo.png' alt='logo' style={{height:"50px"}}/>

                {/* {(alwaysShowText) &&
                    <h5>Tawaf</h5>
                } */}
            </div>
        </>
    )
}
